import type { useT } from "@/i18n";

type T = ReturnType<typeof useT>["t"];

export function requestTypeLabel(t: T, type: string): string {
  const keys: Record<string, Parameters<T>[0]> = {
    factura_electronica: "type.factura_electronica",
    firma_digital: "type.firma_digital",
    ssl: "type.ssl",
    autenticacion: "type.autenticacion",
  };
  return keys[type] ? t(keys[type]) : type;
}

/** Localized validity period from months (PC-35) — 3, 6, 12, 24, legacy 36. */
export function validityLabel(t: T, months: number): string {
  if (months === 3) return t("req.validity_m3");
  if (months === 6) return t("req.validity_m6");
  if (months === 12) return t("req.validity_1");
  if (months === 24) return t("req.validity_2");
  if (months === 36) return t("req.validity_3");
  return `${months}m`;
}
